/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Playdata_Nav_AboutInputs */

const ja_playdata_nav_about = /** @type {(inputs: Playdata_Nav_AboutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PLAYDATAについて`)
};

const en_playdata_nav_about = /** @type {(inputs: Playdata_Nav_AboutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`About`)
};

/**
* | output |
* | --- |
* | "About" |
*
* @param {Playdata_Nav_AboutInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const playdata_nav_about = /** @type {((inputs?: Playdata_Nav_AboutInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Playdata_Nav_AboutInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_playdata_nav_about(inputs)
	return en_playdata_nav_about(inputs)
});